import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function GoToTop({ offset = 0 }) {
    const routePath = useLocation();

    useEffect(() => {
        // Move the onTop function inside the useEffect
        const onTop = () => {
            window.scrollTo({
                top: offset, // Use the offset to scroll below the background image
                behavior: "auto", // Instant jump, no smooth scroll
            });
        };

        onTop();
    }, [routePath, offset]); // Also include 'offset' as a dependency if it's a prop

    return null;
}
